module.exports = __webpack_public_path__ + "static/media/HomeBottom.595de4f7.png";